var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":"text"}},[_vm._v(_vm._s(_vm.data.label))]),(_vm.isActive)?_c('span',{staticClass:"setting-icon",on:{"click":_vm.openSettings}},[_c('i',{staticClass:"el-icon-s-tools"})]):_vm._e(),_c('div',{staticClass:"rectangular-block",style:(_vm.getStyle),domProps:{"innerHTML":_vm._s(_vm.data.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }